<div
    class="h-100vh pt-50 pb-50"
    [class.component-dark-theme]="themeService.isDark()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.card-border-radius]="themeService.isCardBorderRadius()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="tagus-form ms-auto me-auto">
                <div class="title">
                    <div
                        class="d-flex mb-10 align-items-center justify-content-center"
                    >
                        <!-- <h2 class="mb-0 me-30">Get Started</h2> -->
                        <img src="assets/img/logo-icon.png" alt="logo-icon" />
                    </div>
                    <!-- <p>
                        Don’t have an account?
                        <a
                            [routerLink]="
                                '/' +
                                AuthenticationRoutes.authentication +
                                '/' +
                                AuthenticationRoutes.registration
                            "
                            class="main-color fw-medium"
                            >Register now!</a
                        >
                    </p> -->
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div
                        class="login-with-socials d-md-flex align-items-center justify-content-space-between"
                        *ngIf="false"
                    >
                        <button
                            mat-flat-button
                            class="gray fw-semibold d-block me-5"
                        >
                            <img
                                src="assets/img/icon/google.png"
                                alt="google"
                            />
                            Login with Google
                        </button>
                        <button
                            mat-flat-button
                            class="tagus fw-semibold d-block ms-5"
                        >
                            <img
                                src="assets/img/icon/facebook.png"
                                alt="facebook"
                            />
                            Login with Facebook
                        </button>
                    </div>
                    <div class="or text-center position-relative" *ngIf="false">
                        <span class="fw-semibold fs-16">or</span>
                    </div>
                    <div class="bg-white border-radius pt-20 ps-20 pe-20">
                        <div class="tagus-form-group without-icon">
                            <label class="d-block mb-12 fw-semibold gray-color"
                                >Email Address <span>*</span></label
                            >
                            <mat-form-field appearance="fill">
                                <mat-label
                                    class="form-label"
                                    for="txt-email-address"
                                    >Enter email address</mat-label
                                >
                                <input
                                    matInput
                                    class="form-control"
                                    id="txt-email-address"
                                    placeholder="Enter email address"
                                    type="text"
                                    formControlName="email"
                                    [ngClass]="{
                                        'is-invalid':
                                            showFieldError(f['email']) &&
                                            f['email'].errors
                                    }"
                                    (input)="trimEmail()"
                                />
                            </mat-form-field>
                        </div>
                        <div class="tagus-form-group without-icon">
                            <label
                                for="txt-password"
                                class="d-block mb-12 fw-semibold gray-color form-label"
                                >Password <span>*</span></label
                            >
                            <mat-form-field appearance="fill">
                                <mat-label>Enter your password</mat-label>
                                <input
                                    matInput
                                    [type]="hide ? 'password' : 'text'"
                                    class="form-control"
                                    id="txt-password"
                                    placeholder="Enter your password"
                                    formControlName="password"
                                    [ngClass]="{
                                        'is-invalid':
                                            showFieldError(f['password']) &&
                                            f['password'].errors
                                    }"
                                />
                                <button
                                    type="button"
                                    mat-icon-button
                                    matSuffix
                                    (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hide"
                                >
                                    <mat-icon>{{
                                        hide ? "visibility_off" : "visibility"
                                    }}</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <!-- <div
                            class="alert alert-danger mt-5"
                            *ngIf="!loginForm.get('password')?.valid && loginForm.get('password')?.dirty"
                          >
                            Password must contain more than 8 characters, 1 upper case letter, and 1
                            special character
                          </div> -->

                        <div class="tagus-form-group without-icon">
                            <label
                                for="txt-twoFact"
                                class="d-block mb-12 fw-semibold gray-color form-label"
                                >Two-Factor Auth Code
                                <!-- <span>*</span> -->
                            </label>
                            <mat-form-field appearance="fill">
                                <mat-label>Enter your code</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    class="form-control"
                                    id="txt-twoFact"
                                    placeholder="exp 92982"
                                    formControlName="twoFactorAuthCode"
                                    [ngClass]="{
                                        'is-invalid':
                                            showFieldError(
                                                f['twoFactorAuthCode']
                                            ) && f['twoFactorAuthCode'].errors
                                    }"
                                />
                                <!-- <button
                                    mat-icon-button
                                    matSuffix
                                    (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hide"
                                >
                                    <mat-icon>{{
                                        hide ? "visibility_off" : "visibility"
                                    }}</mat-icon>
                                </button> -->
                            </mat-form-field>
                        </div>
                    </div>
                    <div
                        class="d-flex info align-items-center justify-content-end"
                    >
                        <mat-checkbox
                            class="gray-color"
                            formControlName="remember"
                            *ngIf="false"
                        >
                            Remember me
                        </mat-checkbox>
                        <a
                            [routerLink]="
                                '/' +
                                AuthenticationRoutes.authentication +
                                '/' +
                                AuthenticationRoutes.forgotPassword
                            "
                            class="d-inline-block main-color fw-medium"
                            >Forgot your password?</a
                        >
                    </div>
                    <button
                        mat-flat-button
                        class="tagus d-block fw-semibold"
                        type="submit"
                    >
                        Log In
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
